// Espelha o filtro de equipe do ConversationFinder (validate_conversations_by_team)
// para conversas que chegam pelo tempo real e ainda não estão na lista.
const TEAM_SCOPED_ROLES = ['agent', 'supervisor'];

const isTeamScopedUser = user => {
  if (!user || user.type === 'SuperAdmin') return false;
  const permissions = user.permissions || {};
  return (
    TEAM_SCOPED_ROLES.includes(user.type_role) &&
    !permissions.see_all_conversations &&
    !!permissions.see_conversations_team
  );
};

export const canSeeConversationByTeam = (
  conversation,
  { user, teams = [], inbox } = {}
) => {
  if (!isTeamScopedUser(user)) return true;
  // Sem as equipes carregadas não dá para decidir: não esconde.
  if (!teams.length) return true;
  if (inbox?.channel_type === 'Channel::Internal') return true;

  const meta = conversation?.meta || {};
  const teamId = meta.team?.id;
  const assigneeId = meta.assignee?.id;

  if (assigneeId && assigneeId === user.id) return true;
  if (meta.sender?.agent_id && meta.sender.agent_id === user.id) return true;
  if (teamId) {
    return teams.some(team => team.id === teamId && team.is_member);
  }
  return !assigneeId;
};
